import './init';
export { VERSION } from './lib/utils/globals';
export { self, window, global, document, process, console } from './env/globals';
export { default as isBrowser, isBrowserMainThread } from './env/is-browser';
export { default as getBrowser, isMobile } from './env/get-browser';
export { default as isElectron } from './env/is-electron';
export { default as assert } from './env/assert';
export { default as Stats } from './lib/stats';
export { default as Log } from './lib/log';
export { COLOR } from './lib/utils/color';
import { default as Log } from './lib/log';
export default new Log({
  id: 'probe.gl'
});
export { enableDOMLogging as _enableDOMLogging } from './lib/utils/log-to-dom';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/probe.gl/dist/esm/index.js
// module id = 169
// module chunks = 0